import { useMemo } from 'react';
import { roleNames } from '@/constants/role-names';
import { api } from '@/redux/api';
import { ApplicationRole } from '@/types/application-role';
import { usePlatformAdminOrganisationOverride } from './use-platform-admin-organisation-override';
import { useUserRole } from './use-user-role';

export const useRoles = () => {
  const { isPlatformAdmin, isOrgAdmin } = useUserRole();
  const { hasOverride: hasPlatformAdminOrganisationOverride } =
    usePlatformAdminOrganisationOverride();

  const result = api.useGetRolesQuery();

  const data = useMemo(() => {
    let data: ApplicationRole[] = [];

    if (result.data) {
      if (isPlatformAdmin) {
        data = result.data;
      }

      if (isOrgAdmin || hasPlatformAdminOrganisationOverride) {
        data = result.data.filter(
          ({ roleName }) => roleName !== roleNames.platformAdmin,
        );
      }
    }

    return data;
  }, [
    hasPlatformAdminOrganisationOverride,
    isPlatformAdmin,
    isOrgAdmin,
    result.data,
  ]);

  return { ...result, data };
};
